import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Button,
	notification,
	Row,
	Statistic,
	Col,
	Upload,
	Modal,
	Select,
	Tabs,
} from "antd";
import Layout from "../layout/Layout";
import {
	CustomSearch,
	CustomSpinner,
	CustomTable,
} from "../utils/CustomComponents";
import {
	CommentOutlined,
	EditFilled,
	FilePdfFilled,
	InboxOutlined,
	SaveOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";
import dayjs from "dayjs";
import LienComment from "./LienComment";

const { Text } = Typography;
const { Dragger } = Upload;

const LienDashboard = ({ history }) => {
	const [loading, setLoading] = useState(false);
	const [isUploadLoading, setIsUploadLoading] = useState(false);
	const [lienList, setLienList] = useState([]);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [modalCommentsOpen, setModalCommentsOpen] = useState(false);
	const currentLienId = useRef(null);
	const [apiNotification, contextHolder] = notification.useNotification();
	const [tabIndex, setTabIndex] = useState("1");
	const [term, setTerm] = useState("");

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Document No",
			dataIndex: "documentNo",
			key: "documentNo",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Property Owner's Name",
			dataIndex: "ownerName",
			key: "ownerName",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Property Owner's Address",
			dataIndex: "ownerAddress",
			key: "ownerAddress",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Contractor's Name",
			dataIndex: "contractorName",
			key: "contractorName",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Contractor's Address",
			dataIndex: "contractorAddress",
			key: "contractorAddress",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Company Name",
			dataIndex: "companyName",
			key: "companyName",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Company Address",
			dataIndex: "companyAddress",
			key: "companyAddress",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Property Address",
			dataIndex: "propertyAddress",
			key: "propertyAddress",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Deadline",
			dataIndex: "deadline",
			key: "deadline",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Description of Materials",
			dataIndex: "descriptionMaterials",
			key: "descriptionMaterials",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Date Delivered",
			dataIndex: "dateDelivered",
			key: "dateDelivered",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Price of Materials",
			dataIndex: "amountCharged",
			key: "amountCharged",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						prefix={"$"}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Princial Amount Owned",
			dataIndex: "principalAmountOwned",
			key: "principalAmountOwned",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						prefix={"$"}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Montly Interest Amount",
			dataIndex: "montlyInterestAmount",
			key: "montlyInterestAmount",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						prefix={"$"}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Total Amount Owned",
			dataIndex: "totalAmountOwned",
			key: "totalAmountOwned",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						prefix={"$"}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Status",
			dataIndex: "statusPost",
			key: "statusPost",
			render: (value, record) => {
				return (
					<Select
						value={value}
						style={{ width: 150 }}
						options={[
							{
								value: "In Process",
								label: "In Process",
							},
							{
								value: "Intent to Lien",
								label: "Intent to Lien",
							},
							{
								value: "Lien Affidavit",
								label: "Lien Affidavit",
							},
							{
								value: "Closed",
								label: "Closed",
							},
						]}
						onChange={(val) => {
							const updatedLienList = lienList.map((item) => {
								if (item.id === record.id) {
									return { ...item, statusPost: val, changed: true };
								}
								return item;
							});
							setLienList(updatedLienList);
						}}
					/>
				);
			},
		},
		{
			title: "",
			dataIndex: "edit",
			width: 200,
			render: (_, record) => {
				return (
					<Row gutter={16}>
						<Button
							type="primary"
							icon={<EditFilled twoToneColor={"white"} />}
							onClick={(e) => history.push(`/lien/update/${record.id}`)}
						/>
						&nbsp;
						<Button
							type="primary"
							danger
							icon={<FilePdfFilled twoToneColor={"white"} />}
							onClick={(e) => history.push(`/lien/pdf/${record.id}`)}
						/>
						&nbsp;
						<Button
							type="primary"
							icon={<CommentOutlined twoToneColor={"white"} />}
							onClick={() => {
								currentLienId.current = record.id;
								setModalCommentsOpen(true);
							}}
						/>
						&nbsp;
						<Button
							type="primary"
							style={{ backgroundColor: "green" }}
							icon={<SaveOutlined twoToneColor={"white"} />}
							onClick={() => {
								updateLien(record.id, record.statusPost);
							}}
							disabled={!record.changed}
						/>
					</Row>
				);
			},
		},
	];

	useEffect(() => {
		getLienListAll();
	}, []);

	const getLienListAll = async () => {
		setLoading(true);
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const url = api + `/lien/list/all`;

		try {
			const { data } = await axios.get(url);
			let list = [];

			if (data.success) {
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						documentNo: item.documentNo || "N/A",
						date: Intl.DateTimeFormat("en-US").format(new Date(item.createdAt)),
						ownerName: item.ownerName,
						ownerAddress: item.ownerAddress,
						contractorName: item.contractorName,
						contractorAddress: item.contractorAddress,
						companyName: item.companyName,
						companyAddress: item.companyAddress,
						propertyAddress: item.propertyAddress,
						deadline: Intl.DateTimeFormat("en-US").format(
							new Date(item.deadline)
						),
						descriptionMaterials: item.descriptionMaterials,
						dateDelivered: Intl.DateTimeFormat("en-US").format(
							new Date(item.dateDelivered)
						),
						amountCharged: item.amountCharged,
						principalAmountOwned: item.principalAmountOwned,
						montlyInterestAmount: item.montlyInterestAmount,
						totalAmountOwned: item.totalAmountOwned,
						status: item.status || "In Process",
						statusPost: item.status || "In Process",
						changed: false,
					});
				});
				setLienList(list);
			} else {
				openNotification("error", "Error", data.message);
			}

			setLoading(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const getLienList = async (startDate, endDate, term) => {
		setLoading(true);

		const start = `${startDate.year()}-${
			startDate.month() + 1
		}-${startDate.date()}`;
		const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const url =
			api + `/lien/list?startDate=${start}&endDate=${end}&term=${term}`;

		try {
			const { data } = await axios.get(url);
			let list = [];

			if (data.success) {
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						documentNo: item.documentNo || "N/A",
						date: Intl.DateTimeFormat("en-US").format(new Date(item.createdAt)),
						ownerName: item.ownerName,
						ownerAddress: item.ownerAddress,
						contractorName: item.contractorName,
						contractorAddress: item.contractorAddress,
						companyName: item.companyName,
						companyAddress: item.companyAddress,
						propertyAddress: item.propertyAddress,
						deadline: Intl.DateTimeFormat("en-US").format(
							new Date(item.deadline)
						),
						descriptionMaterials: item.descriptionMaterials,
						dateDelivered: Intl.DateTimeFormat("en-US").format(
							new Date(item.dateDelivered)
						),
						amountCharged: item.amountCharged,
						principalAmountOwned: item.principalAmountOwned,
						montlyInterestAmount: item.montlyInterestAmount,
						totalAmountOwned: item.totalAmountOwned,
						status: item.status || "In Process",
						statusPost: item.status || "In Process",
						changed: false,
					});
				});
				setLienList(list);
			} else {
				openNotification("error", "Error", data.message);
			}

			setLoading(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const updateLien = async (id, status) => {
		setLoading(true);

		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const url = api + `/lien/update/status/${id}`;

		try {
			const { data } = await axios.patch(url, { status });

			if (data.success) {
				openNotification("success", "Success", data.message);
				const updatedLienList = lienList.map((item) => {
					if (item.id === id) {
						return { ...item, changed: false, status: status };
					}
					return { ...item, changed: false, statusPost: item.status };
				});
				setLienList(updatedLienList);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const onClickNewLien = () => {
		history.push("/lien/new");
	};

	const createLiens = async (values) => {
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const url = api + `/lien/file/create`;

		try {
			const { data } = await axios.post(url, { items: values });

			openNotification(
				data.success ? "success" : "error",
				data.success ? "Success" : "Error",
				data.message
			);
			setIsUploadLoading(false);
			if (data.success) getLienList("");
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const handleFileUpload = (file) => {
		setIsUploadLoading(true);
		const reader = new FileReader();

		reader.onload = async (e) => {
			const binaryString = e.target.result;

			// Parse Excel file using XLSX library
			const workbook = XLSX.read(binaryString, { type: "binary" });

			// Assuming the first sheet is the one we want
			const sheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[sheetName];

			// Convert the sheet to JSON
			const jsonData = XLSX.utils.sheet_to_json(worksheet, {
				header: 1,
			});

			if (jsonData.length > 0) {
				const dataWithoutFirstFourRows = jsonData.slice(1);

				const rows = dataWithoutFirstFourRows.map((row) => row);
				let items = [];

				for (let i = 0; i < rows.length; i++) {
					const item = rows[i];
					const documentNo = item[0];
					const ownerName = item[1];
					const ownerAddress = item[2];
					const contractorName = item[3];
					const contractorAddress = item[4];
					const companyName = item[5];
					const companyAddress = item[6];
					const propertyAddress = item[7];
					const deadlineParse = XLSX.SSF.parse_date_code(item[8]);
					const deadline = `${deadlineParse.y}-${String(
						deadlineParse.m
					).padStart(2, "0")}-${String(deadlineParse.d).padStart(2, "0")}`;
					const descriptionMaterials = item[9];
					const dateDeliveredParse = XLSX.SSF.parse_date_code(item[10]);
					const dateDelivered = `${dateDeliveredParse.y}-${String(
						dateDeliveredParse.m
					).padStart(2, "0")}-${String(dateDeliveredParse.d).padStart(2, "0")}`;
					const amountCharged = Number(item[11]);
					const principalAmountOwned = Number(item[12]);
					const montlyInterestAmount = Number(item[13]);
					const totalAmountOwned = Number(item[14]);

					items.push({
						documentNo,
						ownerName,
						ownerAddress,
						contractorName,
						contractorAddress,
						companyName,
						companyAddress,
						propertyAddress,
						deadline,
						descriptionMaterials,
						dateDelivered,
						amountCharged,
						principalAmountOwned,
						montlyInterestAmount,
						totalAmountOwned,
					});
				}
				setIsUploadLoading(false);
				await createLiens(items);
			} else {
				setIsUploadLoading(false);

				openNotification(
					"warning",
					"Warning",
					"Excel File do not have any content"
				);
			}
		};

		reader.readAsBinaryString(file); // Read the file as binary string
		return false; // Prevent default upload behavior
	};

	// 	value: "Intent to Lien",
	// 	label: "Intent to Lien",
	// },
	// {
	// 	value: "Lien Affidavit",
	// 	label: "Lien Affidavit",
	// },
	// {
	// 	value: "Closed",
	// 	label: "Closed",

	const tabItems = [
		{
			key: "1",
			label: "In Process",
			children: (
				<TableTab
					columns={columns}
					list={lienList.filter((item) => item.status === "In Process")}
				/>
			),
		},
		{
			key: "2",
			label: "Intent to Lien",
			children: (
				<TableTab
					columns={columns}
					list={lienList.filter((item) => item.status === "Intent to Lien")}
				/>
			),
		},
		{
			key: "3",
			label: "Lien Affidavit",
			children: (
				<TableTab
					columns={columns}
					list={lienList.filter((item) => item.status === "Lien Affidavit")}
				/>
			),
		},
		{
			key: "4",
			label: "Closed",
			children: (
				<TableTab
					columns={columns}
					list={lienList.filter((item) => item.status === "Closed")}
				/>
			),
		},
	];

	const RenderTabs = () => {
		return (
			<Tabs
				defaultActiveKey="1"
				onChange={(val) => setTabIndex(val)}
				activeKey={tabIndex}
				items={tabItems}
			/>
		);
		// return (
		// 	<TableTab
		// 		columns={columns}
		// 		list={lienList.filter((item) => item.status === "In Process")}
		// 	/>
		// );
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
			getLienList(dates[0], dates[1], term);
		}
	};

	const RenderSearch = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Dragger
					name="file"
					multiple={false}
					beforeUpload={handleFileUpload}
					showUploadList={false}
					accept=".xlsx,.xls"
					disabled={isUploadLoading}
				>
					{isUploadLoading ? (
						<CustomSpinner />
					) : (
						<div>
							<p className="ant-upload-drag-icon">
								<InboxOutlined />
							</p>
							<p className="ant-upload-text">
								Click or drag file to this area to upload
							</p>
							<p className="ant-upload-hint">
								Support for a single xlsx file to upload liens
							</p>
						</div>
					)}
				</Dragger>
				<CustomSearch
					onSearch={onSearch}
					loading={loading}
					startDate={startDate}
					endDate={endDate}
					onRangeChange={onRangeChange}
					dateFormat={"MM/DD/YYYY"}
				/>
				<Row gap={[16, 16]}>
					<Col>
						<Button type="primary" onClick={onClickNewLien} size="large">
							Add new lien
						</Button>
					</Col>
				</Row>
			</Flex>
		);
	};

	const onSearch = (value, _e, info) => {
		if (info?.source === "input") {
			setTerm(value);
			getLienList(startDate, endDate, value);
		}
	};

	const onSuccessComment = () => {
		setModalCommentsOpen(false);
		currentLienId.current = null;
	};

	const ModalComments = () => {
		return (
			<Modal
				title="Claim Comments"
				open={modalCommentsOpen}
				onCancel={() => setModalCommentsOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<LienComment
					lienId={currentLienId.current}
					onSuccess={onSuccessComment}
				/>
			</Modal>
		);
	};

	return (
		<Layout title="Lien Dashboard" description="Dashboard">
			{contextHolder}
			<Flex vertical gap={"large"}>
				<RenderSearch />
				{loading ? <CustomSpinner /> : <RenderTabs />}
				<ModalComments />
			</Flex>
		</Layout>
	);
};

export default LienDashboard;

const TableTab = ({ columns, list }) => {
	return <CustomTable columns={columns} data={list} isScroll={true} />;
};
